<!-- =========================================================================================
  File Name: List.vue
  Description: Partner List page
========================================================================================== -->

<template>

  <div id="page-partner-list">

    <vx-card ref="filterCard" title="Фильтры" class="partner-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Программа</label>
          <v-select :options="programsOptions()" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="programsFilter" class="mb-4 md:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Статус</label>
          <v-select :options="statusOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="statusFilter" class="mb-4 md:mb-0" />
        </div>
        <!-- <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Verified</label>
          <v-select :options="isVerifiedOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="isVerifiedFilter" class="mb-4 sm:mb-0" />
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">Department</label>
          <v-select :options="departmentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" v-model="departmentFilter" />
        </div> -->
      </div>
    </vx-card>

    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">

        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ partnersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : partnersData.length }} of {{ partnersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <vs-dropdown-menu>

              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(250)">
                <span>250</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>


        <div class="flex-grow">
          <vs-button color="success" icon-pack="feather" icon="icon-plus" class="mr-4" :to="{name: 'apps-partners-create', params: { partnerId: $route.params.partnerId }}">Создать</vs-button>
        
        </div>



        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Поиск..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Действия</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Удалить</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Архивировать</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Печатать</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Таблица CSV</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>

      </div>


      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="partnersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="false"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl">
      </ag-grid-vue>

      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'

// Store Module
import modulePartner from '@/store/partner/modulePartner.js'

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue"
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue"
import CellRendererProgram from "./cell-renderer/CellRendererProgram.vue"
import CellRendererName from "./cell-renderer/CellRendererName.vue"


export default {
  components: {
    AgGridVue,
    vSelect,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererProgram,
    CellRendererName,
  },
  data() {
    return {


      statusFilter: { label: 'Все', value: 'all' },
      statusOptions: [],

      programsFilter: { label: 'Все', value: 'all' },
      // programsOptions: [],
      
      searchQuery: "",

      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        suppressMovable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ID',
          field: 'partid',
          width: 110,
          filter: true,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: 'Компания',
          field: 'company',
          filter: true,
          width: 300,
          cellRendererFramework: 'CellRendererLink'
        },
        {
          headerName: 'Программа',
          field: 'program',
          // filter: true,
          width: 300,
          cellRendererFramework: 'CellRendererProgram',
        },
        {
          headerName: 'Статус',
          field: 'state',
          // filter: true,
          width: 140,
          cellRendererFramework: 'CellRendererStatus',
        },
        {
          headerName: 'Имя',
          field: 'fname',
          filter: true,
          width: 220,
          cellRendererFramework: 'CellRendererName',
        },
        {
          headerName: 'Должность',
          field: 'position',
          filter: true,
          width: 150,
        },
        {
          headerName: 'Адрес',
          field: 'address',
          filter: true,
          width: 400,
        },
        {
          headerName: 'Время работы',
          field: 'worktime',
          // filter: true,
          width: 250,
        },
        {
          headerName: 'Web-Сайт',
          field: 'website',
          filter: true,
          width: 150,
        },
        {
          headerName: 'E-mail',
          field: 'email',
          filter: true,
          width: 150,
        },
        {
          headerName: 'Телефон',
          field: 'phone',
          filter: true,
          width: 225,
        },
        {
          headerName: 'Время создания',
          field: 'time',
          // filter: true,
          width: 225,
        },
      ],



      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererProgram,
        CellRendererName,
      }
    }
  },
  watch: {
    statusFilter(obj) {
      this.setColumnFilter("state", obj.value)
    },
    programsFilter(obj) {
      this.setColumnFilter("program", obj.value)
    },
  },
  computed: {
    programs_data() {
      return this.$store.state.partner.programs
    },
    partnersData() {
      return this.$store.state.partner.partners
    },
    paginationPageSize() {
      if(this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    totalPages() {
      if(this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    currentPage: {
      get() {
        if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    programsOptions() {
      let options = []
      this.programs_data.forEach(prog => {
        options.push({ label: prog.name, value: prog.ppid })
      })
      options.unshift({ label: 'Все', value: 'all' })
      return options
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if(val !== "all") {
        modelObj = { type: "equals", filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.programsFilter = this.statusFilter = { label: 'Все', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val)
    }
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if(this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container")
      header.style.left = "-" + String(Number(header.style.transform.slice(11,-3)) + 9) + "px"
    }
  },
  created() {
    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }

    this.$store.dispatch("partner/fetchPartners")
    .then(() => {
      let partid = this.$route.params.partnerId
      if (partid) {
        this.searchQuery = partid
        this.updateSearchQuery(partid)
      }
    })
    this.$store.dispatch("partner/fetchPrograms")

    this.statusOptions = Object.assign([], modulePartner.partnerStateList)
    this.statusOptions.unshift({ label: 'Все', value: 'all' })
  },
}

</script>

<style lang="scss">
#page-partner-list {
  .ag-theme-material .ag-cell {
    padding-right: 10px;
  }
  .vs__selected-options {
    max-width: 100%;
  }
  .vs__selected {
    white-space: nowrap;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 85%;
  }
  .partner-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
